import React, { useEffect, useState } from "react";
import { FaUpload } from "react-icons/fa";
import addChangeMessage from "../../../../controllers/booking/postTicketing/change/addMessage";
import { enqueueSnackbar } from "notistack";
import { useSelector } from "react-redux";

function RenameConfirmationRemarksSection({ data }) {
  const { user } = useSelector((state) => state.user?.userData);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [conversation, setConversation] = useState(data?.conversation || []);

  useEffect(() => {
    if (data?.conversation?.length) {
      setConversation(data?.conversation);
    }
  }, [data]);

  if (
    !["Pending", "Approved"].includes(data?.status) &&
    conversation?.length === 0
  )
    return <></>;

  const handleReply = async () => {
    if (!message)
      return enqueueSnackbar("Please enter your a message first", {
        variant: "info",
      });
    setLoading(true);
    const res = await addChangeMessage(data?._id, { message }).finally(() =>
      setLoading(false)
    );
    if (res?.return) {
      setMessage("");
      setConversation([...conversation, res?.data]);
    } else {
      enqueueSnackbar(
        res?.message || "Something is wrong. Please try again later.",
        { variant: "error" }
      );
    }
  };

  return (
    <div className="w-full bg-white rounded-xl border border-gray-200 p-5 mt-4">
      {/* Header */}
      <span className="block font-semibold text-gray-900 text-base mb-2">
        Remarks
      </span>

      {/* Conversation messages */}
      <div className="text-sm mb-4">
        {conversation?.map((message, messageIndex) => (
          <span className="block mb-1" key={messageIndex}>
            <span className="font-medium text-gray-900">
              {user?._id === message?.account ? "Me" : "Customer"}:
            </span>{" "}
            <span className="text-gray-700">{message?.message}</span>
          </span>
        ))}
        {/* <span className="block">
          <span className="font-medium text-gray-900">CS:</span>{" "}
          <span className="text-gray-700">
            This has been noted and is under review.
          </span>
        </span> */}
      </div>
      {["Pending", "Approved"].includes(data?.status) ? (
        <>
          <textarea
            rows="4"
            placeholder=""
            className="w-full bg-gray-100 text-sm rounded-lg p-3 text-gray-700 border border-gray-200 outline-none resize-none focus:border-transparent"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />

          {/* Action buttons */}
          <div className="flex items-center justify-between mt-4 flex-wrap gap-3">
            <div className="flex items-center gap-2">
              <button
                type="button"
                disabled={loading}
                className="bg-primary1 disabled:bg-gray-600 text-white text-sm font-medium w-20 flex items-center justify-center h-9 rounded-md"
                onClick={() => handleReply()}
              >
                {loading ? <div className="buttonLoader"></div> : <>Reply</>}
              </button>
              <button
                type="button"
                className="flex items-center gap-2 bg-gray-200 hover:bg-gray-300 text-gray-700 text-sm font-medium px-4 py-2 rounded-md"
              >
                <FaUpload size={14} />
                Upload
              </button>
            </div>

            <span className="text-xs text-gray-500">
              Jpeg, png, doc, pdf, zip, rar, Size not more than 2M
            </span>
          </div>
        </>
      ) : (
        <></>
      )}

      {/* Textarea */}
    </div>
  );
}

export default RenameConfirmationRemarksSection;
